'use strict';

import {Point2D} from '../util/Geometry.js';
import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import {Bounds} from '../content/BoxContent.js'

const privateMap = util.createPrivateMapper();

function handleMousemove(pv, ev){
  const view = pv.view;
  if (!view || !view.control.box) {
    return;
  }
  if (!view.annotationListResources || !view.annotationListResources.length) {
    return;
  }
  const mousePoint = view.control.box.getBoxPoint(domUtil.getPixel(view.domEl, new Point2D(ev.clientX, ev.clientY)));
  const regionsMap = {};
  util.each(view.annotationListResources, (annoRes) => {
    regionsMap[annoRes.id] = annoRes.getRegionByPixel(mousePoint);
  });
  pv.view.selectAnnotations('hover', regionsMap);
}
function handleMouseout(pv, ev){
  const view = pv.view;
  if (!view || !view.control.box) {
    return;
  }
  if (!view.annotationListResources || !view.annotationListResources.length) {
    return;
  }
  pv.view.selectAnnotations('hover');
}
function handleClick(pv, ev){
  const view = pv.view;
  if (!view || !view.control.box) {
    return;
  }
  if (!view.annotationListResources || !view.annotationListResources.length) {
    return;
  }
  const mousePoint = view.control.box.getBoxPoint(domUtil.getPixel(view.domEl, new Point2D(ev.clientX, ev.clientY)));
  const target = {};
  util.each(view.annotationListResources, (annoRes) => {
    const regions = annoRes.getRegionByPixel(mousePoint);
    if (regions && regions.length > 0) {
      target.listId = annoRes.id;
      target.annotationId = regions[0];
      return false;
    }
  });

  pv.view.focusAnnotation(target.listId, target.annotationId);
}

export class Annotation2DListControl {

  constructor(){
    const pv = privateMap(this);
    pv.view = null;
    // pv.dragged = false;
    pv.mousemoveHandler = (ev) => {
      // if (pv.dragged) {
      //   return;
      // }
      handleMousemove(pv, ev);
    };
    pv.mouseoutHandler = (ev) => {
      handleMouseout(pv, ev);
    };
    pv.clickHandler = (ev) => {
      // if (pv.dragged) {
      //   pv.dragged = false;
      //   return;
      // }
      handleClick(pv, ev);
    };
    // pv.mousedownHandler = (ev) => {
    //   const basePt = new Point2D(ev.clientX, ev.clientY);
    //   const moveHandler = (ev) => {
    //     if (pv.dragged) {
    //       return;
    //     }
    //     const pt = new Point2D(ev.clientX, ev.clientY);
    //     console.log(pt, basePt);
    //     if (pt.sub(basePt).distance() > 0) {
    //       pv.dragged = true;
    //     }
    //   };
    //   domUtil.addEventListener(window, 'mousemove', moveHandler);

    //   const endHandler = function(){
    //     console.log('mouseup');
    //     domUtil.removeEventListener(window, 'mousemove', moveHandler);
    //     domUtil.removeEventListener(window, 'mouseup', endHandler);
    //   };
    //   domUtil.addEventListener(window, 'mouseup', endHandler);
    //   console.log('OK!');
    // };
  }

  link(view) {
    const pv = privateMap(this);
    if (pv.view) {
      this.unlink();
    }
    pv.view = view;
    if (!pv.view) {
      return;
    }
    // pv.boxControl = view.renderer.boxControl;
    domUtil.addEventListener(pv.view.eventLayer, 'click', pv.clickHandler);
    // domUtil.addEventListener(pv.view.eventLayer, 'mousedown', pv.mousedownHandler);
    domUtil.addEventListener(pv.view.eventLayer, 'mousemove', pv.mousemoveHandler);
    domUtil.addEventListener(pv.view.eventLayer, 'mouseout', pv.mouseoutHandler);
    this.viewSize = view.size;
    pv.requestRender = function(){
      view.requestRender();
    };
  }

  unlink(){
    const pv = privateMap(this);
    if (!pv.view) {
      return
    }
    domUtil.removeEventListener(pv.view.eventLayer, 'click', pv.clickHandler);
    // domUtil.removeEventListener(pv.view.eventLayer, 'mousedown', pv.mousedownHandler);
    domUtil.removeEventListener(pv.view.eventLayer, 'mousemove', pv.mousemoveHandler);
    domUtil.removeEventListener(pv.view.eventLayer, 'mouseout', pv.mouseoutHandler);
    pv.requestRender = function(){};
    pv.view = null;
  }
}
